export function buildUpSellUrl(lms, offer, baseUrl) {
  const pax = lms.numFreeSeats > 1 ? '42,42' : '42';

  const geo = lms.hotel?.content?.geographical || {};

  let queryResId = geo?.resort?.caId || '-1';

  if (offer.type === 'unspecified' || offer.type === 'flightOnly') {
    queryResId = '-1';
  }

  const upsellQuery = [
    `SelectedDestCd=${lms.destinationCode}`,
    `SelectedDepCd=${lms.departureCode}`,
    `QueryDepDate=${lms.date.raw.split('T')[0].replaceAll('-','')}`,
    `QueryDur=${lms.duration}`,
    `QueryRoomAges=${pax}`,
    'QueryUnits=1',
    `SelectedHotCd=${offer.hotelCode}`,
    `QueryResID=${queryResId}`,
    `QueryCtryID=${geo?.country?.caId || '-1'}`,
    `QueryAreaID=${geo?.area?.caId || '-1'}`,
    `QueryDepID=${lms.departure.caId}`,
    `SelectedSerNo=${lms.serialNumber}`,
    `price=${offer.price * pax.split(',').length}`,
  ].join('&');

  return `${baseUrl}?${upsellQuery}`;
}
